import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useRequestHandler } from "../utils/useRequestHandler";
import Servicios from "../services";
import { useDispatch } from "react-redux";
import { showErrorMessage } from "../redux/appSlice";
import { Autocomplete, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import ImageUploadField from "../components/ImageUploadField";

// Segmentación del envío manual (ver NOTIFICACIONES.md, sección 12): tres
// audiencias concretas en vez de una arquitectura de campañas abierta — son
// los dos casos reales de hoy (todos, solo prueba) más el caso siguiente más
// probable (una penca puntual, p. ej. avisar de una etapa suspendida a los
// integrantes afectados).
const AUDIENCIA_TODOS = "todos";
const AUDIENCIA_PRUEBA = "prueba";
const AUDIENCIA_PENCA = "penca";

const Notificaciones = () => {
  const sendRequest = useRequestHandler();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [imagen, setImagen] = useState(null);
  const [imgPreviewSrc, setImgPreviewSrc] = useState("");
  const [link, setLink] = useState("");
  const dispatch = useDispatch();
  const [audiencia, setAudiencia] = useState(AUDIENCIA_PRUEBA);
  const [pencas, setPencas] = useState([]);
  const [pencaSeleccionada, setPencaSeleccionada] = useState(null);

  useEffect(() => {
    Servicios.ObtenerPencas("").then(setPencas).catch(() => setPencas([]));
  }, []);

  const handleTitleChange = event => {
    setTitle(event.target.value);
  };

  const handleContentChange = event => {
    setContent(event.target.value);
  };

  const [title2, setTitle2] = useState("");
  const [content2, setContent2] = useState("");

  const handleTitleChange2 = event => {
    setTitle2(event.target.value);
  };

  const handleContentChange2 = event => {
    setContent2(event.target.value);
  };

  const handleSubmit = () => {
    if (audiencia === AUDIENCIA_PENCA && !pencaSeleccionada) {
      dispatch(showErrorMessage("Elegí una penca antes de enviar."));
      return;
    }
    if (!window.confirm("¿Confirmás enviar esta notificación push? La acción no se puede deshacer.")) {
      return;
    }
    const modoPrueba = audiencia === AUDIENCIA_PRUEBA;
    const pencaId = audiencia === AUDIENCIA_PENCA ? pencaSeleccionada.id : null;
    sendRequest(Servicios.EnviarNotificaciones, [
      title,
      content,
      title2,
      content2,
      link,
      imagen,
      modoPrueba,
      pencaId
    ]);
    setTitle("");
    setContent("");
    setTitle2("");
    setContent2("");
    setImagen();
    setImgPreviewSrc("");
    setLink("");
  };

  const handleImagenChange = (file, preview) => {
    setImagen(file);
    setImgPreviewSrc(preview);
  };

  return (
    <div className="card-modern">
      <div className="page-header">
        <h5 className="page-title">Notificaciones</h5>
      </div>
      <hr className="border-gray-200 dark:border-gray-700 my-4" />
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <h5 className="page-title">Notificaciones push</h5>
          <div className="mb-3">
            <TextField
              size="small"
              label="Título"
              value={title}
              onChange={handleTitleChange}
            />
          </div>
          <div className="mb-3">
            <TextField
              size="small"
              label="Contenido"
              value={content}
              onChange={handleContentChange}
            />
          </div>
          <hr className="border-gray-200 dark:border-gray-700 my-4" />
          <h5 className="page-title">Diálogo en app abierta</h5>
          <div className="mb-3">
            <TextField
              size="small"
              label="Título"
              value={title2}
              onChange={handleTitleChange2}
            />
          </div>
          <div className="mb-3">
            <TextField
              size="small"
              label="Contenido"
              value={content2}
              onChange={handleContentChange2}
            />
          </div>
          <div className="mb-3">
            <FormControl size="small" className="w-full">
              <InputLabel id="audiencia-label">Audiencia</InputLabel>
              <Select
                labelId="audiencia-label"
                label="Audiencia"
                value={audiencia}
                onChange={e => setAudiencia(e.target.value)}
              >
                <MenuItem value={AUDIENCIA_PRUEBA}>Solo cuentas de prueba</MenuItem>
                <MenuItem value={AUDIENCIA_TODOS}>Todos los usuarios</MenuItem>
                <MenuItem value={AUDIENCIA_PENCA}>Integrantes de una penca</MenuItem>
              </Select>
            </FormControl>
          </div>
          {audiencia === AUDIENCIA_PENCA && (
            <div className="mb-3">
              <Autocomplete
                value={pencaSeleccionada}
                onChange={(event, newValue) => setPencaSeleccionada(newValue)}
                options={pencas}
                getOptionLabel={option => option?.nombre ?? ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={params => (
                  <TextField {...params} size="small" label="Penca" />
                )}
              />
            </div>
          )}
        </div>
        <div className="flex-1 file-upload ms-4">
          <ImageUploadField
            value={imagen}
            previewSrc={imgPreviewSrc}
            onChange={handleImagenChange}
            onError={message => dispatch(showErrorMessage(message))}
          />
        </div>
      </div>
      <div className="mb-3 mt-4">
        <TextField
          className="w-full"
          size="small"
          label="Link"
          value={link}
          onChange={e => setLink(e.target.value)}
        />
      </div>
      <Button className="btn-primary" variant="contained" onClick={handleSubmit}>
        Enviar
      </Button>
    </div>
  );
};

export default Notificaciones;
